import { ThemeOptions } from "@mui/material"

const frostedBackdrop = {
  backgroundColor: "rgba(17, 25, 40, 0.58)",
  backdropFilter: "saturate(160%) blur(30px)",
  border: "1px solid rgba(148, 163, 184, 0.22)",
  borderRadius: "5px",
  boxShadow: "0 20px 50px -28px rgba(15, 23, 42, 0.65)"
}

const darkTheme: ThemeOptions = {
  palette: {
    mode: "dark",
    primary: { main: "#7BC4FF", light: "#9AD5FF", dark: "#3C97D0" },
    secondary: { main: "#D1A5FF", light: "#E5C4FF", dark: "#A071E0" },
    background: { default: "#0B1220", paper: "rgba(11, 18, 32, 0.72)" },
    text: { primary: "#E2E8F0", secondary: "rgba(226, 232, 240, 0.65)" },
    divider: "rgba(148, 163, 184, 0.12)"
  },
  typography: {
    fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
    button: { textTransform: "none", fontWeight: 600, letterSpacing: "0.01em" }
  },
  shape: { borderRadius: 5 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background:
            "radial-gradient(circle at 10% 15%, rgba(47, 94, 157, 0.55) 0%, rgba(15, 23, 42, 0.88) 45%, rgba(10, 19, 32, 0.92) 100%)",
          minHeight: "100vh",
          color: "#E2E8F0"
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: { ...frostedBackdrop, backgroundImage: "linear-gradient(135deg, rgba(15, 23, 42, 0.65), rgba(17, 25, 40, 0.45))" }
      }
    },
    MuiCard: { styleOverrides: { root: { ...frostedBackdrop, borderRadius: "5px", padding: "8px" } } },
    MuiAppBar: { styleOverrides: { root: { ...frostedBackdrop, backgroundColor: "rgba(17, 25, 40, 0.72)" } } },
    MuiDrawer: { styleOverrides: { paper: { ...frostedBackdrop, backgroundColor: "rgba(13, 20, 34, 0.82)" } } },
    MuiDialog: {
      styleOverrides: {
        paper: { ...frostedBackdrop, backgroundImage: "linear-gradient(135deg, rgba(15, 23, 42, 0.72), rgba(17, 25, 40, 0.55))" }
      }
    },
    MuiTooltip: { styleOverrides: { tooltip: { ...frostedBackdrop, color: "#E2E8F0" } } },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 5,
          padding: "6px 16px",
          fontWeight: 600,
          letterSpacing: "0.01em",
          color: "#E2E8F0",
          backgroundImage: "linear-gradient(135deg, rgba(24, 34, 52, 0.75), rgba(32, 44, 67, 0.55))",
          border: "1px solid rgba(148, 163, 184, 0.35)",
          boxShadow: "0 16px 32px -28px rgba(15, 23, 42, 0.85)",
          backdropFilter: "saturate(160%) blur(24px)",
          transition: "all 0.25s ease",
          "&:hover": {
            transform: "translateY(-1px)",
            backgroundImage: "linear-gradient(135deg, rgba(36, 47, 70, 0.85), rgba(46, 64, 95, 0.65))",
            boxShadow: "0 20px 36px -26px rgba(9, 16, 28, 0.9)"
          },
          "&:active": { transform: "translateY(0)", boxShadow: "0 12px 24px -20px rgba(9, 16, 28, 0.85)" },
          "&.Mui-disabled": {
            color: "rgba(226, 232, 240, 0.4)",
            backgroundImage: "linear-gradient(135deg, rgba(24, 34, 52, 0.45), rgba(24, 34, 52, 0.3))",
            borderColor: "rgba(148, 163, 184, 0.2)",
            boxShadow: "none"
          }
        },
        contained: {
          backgroundImage: "linear-gradient(135deg, rgba(47, 72, 112, 0.85), rgba(30, 48, 78, 0.65))",
          borderColor: "rgba(123, 196, 255, 0.45)",
          "&:hover": { backgroundImage: "linear-gradient(135deg, rgba(74, 112, 168, 0.9), rgba(40, 64, 108, 0.7))" }
        },
        outlined: {
          borderColor: "rgba(123, 196, 255, 0.35)",
          backgroundColor: "rgba(15, 23, 42, 0.35)",
          "&:hover": { borderColor: "rgba(123, 196, 255, 0.55)", backgroundColor: "rgba(17, 25, 40, 0.5)" }
        },
        text: {
          border: "1px solid transparent",
          backgroundColor: "rgba(15, 23, 42, 0.25)",
          "&:hover": { borderColor: "rgba(123, 196, 255, 0.25)", backgroundColor: "rgba(22, 32, 50, 0.35)" }
        }
      }
    }
  }
}

export default darkTheme
